import type { ReactElement } from "react";
import { Check, X } from "lucide-react";

interface Row {
  feature: string;
  chill: string | true | false;
  typical: string | true | false;
}

const ROWS: Row[] = [
  { feature: "Update by text or email", chill: true, typical: false },
  { feature: "No editor to learn", chill: true, typical: false },
  { feature: "Custom domain + SSL", chill: true, typical: true },
  { feature: "Someone else makes the change", chill: true, typical: false },
  { feature: "Starting price", chill: "$25 / mo", typical: "$16–23 / mo" },
];

function Cell({
  value,
  accent,
}: {
  value: string | true | false;
  accent: boolean;
}): ReactElement {
  if (value === true) {
    return (
      <Check
        className={accent ? "h-4 w-4 text-[#636793]" : "h-4 w-4 text-[#8a9692]"}
      />
    );
  }
  if (value === false) {
    return <X className="h-4 w-4 text-[#c5ceca]" />;
  }
  return (
    <span
      className={
        accent
          ? "text-sm font-medium text-[#1b2b27]"
          : "text-sm text-[#65736f]"
      }
    >
      {value}
    </span>
  );
}

export function Comparison(): ReactElement {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <div className="marketing-kicker text-[#45635e]">Compare</div>
          <h2 className="marketing-display mt-5 text-4xl leading-[1.02] text-[#12211d] sm:text-5xl">
            Built for people who do not want a builder.
          </h2>
        </div>
        <div className="overflow-hidden rounded-[1.75rem] border border-[#d5e9f7] bg-white">
          <div className="grid grid-cols-3 border-b border-[#d5e9f7] bg-[#f3f9fe] px-5 py-4 text-sm font-semibold sm:px-8">
            <div className="text-[#65736f]"> </div>
            <div className="text-center text-[#20272b]">Chill</div>
            <div className="text-center text-[#65736f]">Typical builders</div>
          </div>
          <div className="divide-y divide-[#d5e9f7]">
            {ROWS.map((row) => (
              <div
                key={row.feature}
                className="grid grid-cols-3 items-center px-5 py-4 text-sm sm:px-8"
              >
                <div className="pr-3 text-[#1b2b27]">{row.feature}</div>
                <div className="flex justify-center">
                  <Cell value={row.chill} accent />
                </div>
                <div className="flex justify-center">
                  <Cell value={row.typical} accent={false} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
